export const CURRENT_YEAR = new Date()?.getFullYear();
export const MIN_AGE = 18;
export const MAX_AGE = 99;